import { Navigate } from 'react-router-dom';

/**
 * Legacy Dice entry — questionnaire now runs `/7_1`…`/7_4` (Submit → `/tng`).
 */
export default function DiceQ1() {
  return <Navigate to="/7_1" replace />;
}
